import React from 'react';
import { FiDollarSign, FiBarChart2, FiTrendingUp } from 'react-icons/fi';

const ValueTab = ({ insightData, Section }) => {
  if (!insightData?.heptapod_dimensional_analysis?.value_intelligence) return null;

  const valueIntel = insightData.heptapod_dimensional_analysis.value_intelligence;

  return (
    <>
      {/* Value Intelligence */}
      <Section title="Value Intelligence" iconComponent={FiDollarSign}>
        <div className="bg-white rounded-2xl border border-gray-200 shadow-xl p-6 mb-6">
          {/* Economic Value */}
          {valueIntel.realized_value?.economic_value && (
            <div className="mb-6">
              <div className="text-sm font-semibold text-gray-900 mb-4 flex items-center gap-2">
                <FiBarChart2 className="text-green-600" />
                Economic Value
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {valueIntel.realized_value.economic_value.direct_roi && (
                  <div className="bg-green-50 border border-green-200 rounded-lg p-4 text-center">
                    <div className="text-xs text-green-600 font-semibold mb-2">DIRECT ROI</div>
                    <div className="text-base text-green-800 font-bold">
                      {valueIntel.realized_value.economic_value.direct_roi}
                    </div>
                  </div>
                )}
                {valueIntel.realized_value.economic_value.cost_avoidance && (
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 text-center">
                    <div className="text-xs text-blue-600 font-semibold mb-2">COST AVOIDANCE</div>
                    <div className="text-base text-blue-800 font-bold">
                      {valueIntel.realized_value.economic_value.cost_avoidance}
                    </div>
                  </div>
                )}
                {valueIntel.realized_value.economic_value.investment_payback && (
                  <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 text-center">
                    <div className="text-xs text-yellow-600 font-semibold mb-2">PAYBACK PERIOD</div>
                    <div className="text-base text-yellow-800 font-bold">
                      {valueIntel.realized_value.economic_value.investment_payback}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Unrealized Potential */}
          {valueIntel.unrealized_potential && (
            <div>
              <div className="text-sm font-semibold text-gray-900 mb-4 flex items-center gap-2">
                <FiTrendingUp className="text-blue-600" />
                Unrealized Potential
              </div>
              <div className="space-y-4">
                {valueIntel.unrealized_potential.map((opportunity, idx) => (
                  <div key={idx} className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                    <div className="flex justify-between items-center mb-3">
                      <div className="font-semibold text-gray-900 text-sm">
                        {opportunity.opportunity_area}
                      </div>
                      <div className="bg-green-100 text-green-800 px-2 py-1 rounded text-xs font-semibold">
                        {opportunity.potential_value}
                      </div>
                    </div>
                    <div className="text-xs text-gray-500 mb-3">
                      Timeline: {opportunity.timeline} • Probability: {opportunity.probability_score}%
                    </div>
                    <div className="text-xs text-gray-700">
                      <strong>Requirements:</strong> {opportunity.realization_requirements?.join(', ')}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </Section>
    </>
  );
};

export default ValueTab;
